import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { RecomendacaoSemeaduraFormValues } from '../../../../@types';
import { FormObject } from '../../../../components/Form/types';
import { Form } from '../form-controller';

const STATUS_OPTIONS = [
  {
    id: 'rascunho',
    descricao: 'Rascunho',
  },
  {
    id: 'publicado',
    descricao: 'Publicado',
  },
];

const SITUACAO_OPTIONS = [
  {
    id: 'aberto',
    descricao: 'Aberto',
  },
  {
    id: 'em_andamento',
    descricao: 'Em Andamento',
  },
  {
    id: 'finalizado',
    descricao: 'Finalizado',
  },
];

const Header = ({ formObject }: PropTypes) => {
  const { setValue, watch, trigger } = formObject.form;
  const params = useParams<{ id: string }>();
  const status = watch('status');

  useEffect(() => {
    if (!params.id) {
      setValue('status', 'rascunho');
      setValue('situacao', 'aberto');
    }
  }, [params.id, setValue]);

  return (
    <div className="recomendacoes-semeadura-create-edit-header">
      <h2 className="text-2xl font-light text-gray">
        Recomendação de Semeadura
      </h2>
      <div className="flex gap-3">
        <Form.Dropdown
          name="status"
          label="Status:"
          containerClassName="flex-1"
          options={STATUS_OPTIONS}
          onChange={() => trigger('periodo')}
          optionLabel="descricao"
          optionValue="id"
          className="w-full"
        />
        <Form.Dropdown
          name="situacao"
          label="Situação:"
          containerClassName="flex-1"
          options={SITUACAO_OPTIONS}
          optionLabel="descricao"
          optionValue="id"
          className="w-full"
          disabled={status === 'rascunho'}
        />
      </div>
    </div>
  );
};

export type PropTypes = {
  formObject: FormObject<RecomendacaoSemeaduraFormValues>;
};

export default Header;
